<template>
  <div
    v-observe-visibility="blockVisibility.getOptions('lazyLoad')"
    :class="$style.block"
  >
    <div
      v-if="canRenderBlock && hasBlockData"
      v-observe-visibility="blockVisibility.getOptions('half')"
    >
      <div :class="$style.title">
        ПЕРСОНАЛЬНАЯ ПОДБОРКА
      </div>

      <div :class="$style.personalRecommendedBlock">

        <personal-selection-item
          v-for="(record, index) of personalsRecords"
          :key="record.id"
          :record="record"
          :class="$style[`record${index + 1}`]"
          @visible="viewRecordHandler(index, record)"
          @click.native="clickRecordHandler(index, record)"
        />

        <adv :adv="adv1" :index="adv1" :class="$style.adv1" />
        <adv :adv="adv2" :index="adv2" :class="$style.adv2" />
        <adv :adv="adv3" :index="adv3" :class="$style.adv3" />
      </div>
    </div>
  </div>
</template>

<script>
  import { guardEmptyArray, guardUnspecified } from '@smh/utils/guards';
  import { ObserverVisibility, StoreMixin } from '@jtnews/shared';

  import { Adv } from '../../../../shared/components/_adv';
  import PersonalSelectionItem from './personal-selection-item/personal-selection-item.component';
  import { PersonalSelectionUseCase } from './personal-selection.usecase';

  export default {
    name: 'RecordPersonalSelection',
    components: {
      Adv,
      PersonalSelectionItem
    },
    mixins: [StoreMixin],
    data() {
      return {
        useCase: null,
        blockVisibility: new ObserverVisibility(['lazyLoad', 'half']),
        canRenderBlock: false,
        personalsRecords: []
      };
    },
    computed: {
      isMobile() {
        return this.store.deviceInfo.isMobile && !this.store.deviceInfo.isTablet;
      },
      regionId() {
        return this.store.regionId;
      },
      envType() {
        return this.store.envType;
      },
      recordId() {
        return this.store.layoutModule.record.data.id;
      },
      adv1() {
        return this.isMobile ?
          this.store.advModule.personalSelectionMobile1AdvBlock :
          this.store.advModule.personalSelectionDesktop1AdvBlock;
      },
      adv2() {
        return this.isMobile ?
          this.store.advModule.personalSelectionMobile2AdvBlock :
          this.store.advModule.personalSelectionDesktop2AdvBlock;
      },
      adv3() {
        return this.isMobile ?
          this.store.advModule.personalSelectionMobile3AdvBlock :
          this.store.advModule.personalSelectionDesktop3AdvBlock;
      },
      hasBlockData() {
        return guardEmptyArray(this.personalsRecords);
      }
    },
    beforeMount() {
      this.useCase = new PersonalSelectionUseCase(this.envType, this.isMobile);
    },
    mounted() {
      this.blockVisibility.event.subscribe((state) => {
        if (state.hook === 'lazyLoad' && state.value && !this.canRenderBlock) {
          this.fetchPersonalRecommendedNews();
        }
      });
    },
    beforeDestroy() {
      this.blockVisibility.destroy();
    },
    methods: {
      async fetchPersonalRecommendedNews() {
        try {
          const result = await this.useCase.getPersonalSelectionBlockData(
            this.regionId,
            this.recordId
          );

          if (guardUnspecified(result)) {
            this.personalsRecords = [...result.data];
          }

        } catch (err) {
          this.personalsRecords = [];
        } finally {
          this.canRenderBlock = true;
        }
      },
      getRecordPosition(index) {
        const map = {
          0: 2,
          1: 3,
          2: 6,
        }

        return map[index]
      },
      viewRecordHandler(index, record) {
        const place = `Место ${this.getRecordPosition(index)}`

        this.sendReachGoalParams({
          goalName: 'viewCompilationBlockML',
          actionType: 'Просмотр',
          prop1: record.id,
          prop2: {
            [place]: {
              [record.type]: record.selectionType
            }
          }
        });
      },
      clickRecordHandler(index, record) {
        const place = `Место ${this.getRecordPosition(index)}`

        this.sendReachGoalParams({
          goalName: 'clickCompilationBlockML',
          actionType: `Переход на материал`,
          prop1: record.id,
          prop2: {
            [place]: {
              [record.type]: record.selectionType
            }
          }
        });
      },
      sendReachGoalParams(data) {
        const {
          actionType,
          goalName,
          prop1,
          prop2
        } = data;

        const blockType = 'Центральная колонка';
        const fieldType = 'Персональная подборка';
        const valueName = {
          [actionType]: {
            [prop1]: prop2
          }
        };

        this.store.analyticsModule.sendNewReachGoal({
          blockType,
          fieldType,
          valueName,
          goalName,
          willDeprecate: true
        });
        this.store.analyticsModule.sendNewFormatReachGoal({
          blockType: fieldType,
          actionType,
          goalName,
          prop1,
          prop2
        });
      }
    }
  };
</script>

<style lang="scss" module>
  @import './personal-selection.styles';
</style>
